module.exports = __webpack_public_path__ + "static/CATALOG_2026-07-aae0f2a08f43afa7d23ca8d2c653ceda.pdf";